import React, { useState } from 'react';
import './Header.css';
import { Navbar, Nav, NavDropdown, Modal, Button } from 'react-bootstrap';
import logo from '../../../assets/images/QuidelOrtho-logo.png';
import { Link } from 'react-router-dom';
import { useFeatures } from '../../../utils/featureContext';
import { FEATURES } from '../../../utils/extractFeaturesList.js';
import packageJson from '../../../../package.json';

const Header = (props) => {
  const [show, setShow] = useState(false);
  const [showVersionModal, setShowVersionModal] = useState(false);
  const { features, loading } = useFeatures();

  const hasAccess = (featureName) => {
    if (loading) return false;
    return features?.includes(featureName);
  };

  const hasScmAccess =
    hasAccess(FEATURES.SCM_ADMIN) ||
    hasAccess(FEATURES.SCM_PACKAGE) ||
    hasAccess(FEATURES.SCM_DEPLOYMENT);

  const showDropdown = () => {
    setShow(!show);
  };
  const hideDropdown = () => {
    setShow(false);
  };

  return (
    <header className='headerContainer'>
      <Navbar expand="lg" className='navBar' >
        <Navbar.Brand as={Link} to="/">
          <img
            src={logo}
            alt=""
            className='logo'
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="justify-content-end navItem" style={{ width: "100%" }}>
            {hasAccess(FEATURES.ASSET_BROWSER) && (
              <Nav.Link as={Link} to="/" className='navList'>Home</Nav.Link>
            )}
            {hasAccess(FEATURES.ASSET_REGISTRATION) && (
              <Nav.Link as={Link} to="/registration" className='navList'>Registration</Nav.Link>
            )}
            {hasAccess(FEATURES.GLOBAL_AUDIT_LOGS) && (
              <Nav.Link as={Link} to="/global-audit-logs" className='navList'>Audit Logs</Nav.Link>
            )}
            {hasScmAccess && (
              <Nav.Link as={Link} to="/software-management" className='navList'>SCM</Nav.Link>
            )}
            {hasAccess(FEATURES.USER_MANAGEMENT) && (
              <Nav.Link as={Link} to="/user-management" className='navList'>User Management</Nav.Link>
            )}

            <Nav.Link
              className='navList'
              onClick={() => setShowVersionModal(true)}
            >
              Version
            </Nav.Link>

            <NavDropdown
              title={`${props.user.given_name} ${props.user.family_name}`}
              id="basic-nav-dropdown"
              className='navList'
              show={show}
              onMouseEnter={showDropdown}
              onMouseLeave={hideDropdown}
              onClick={showDropdown}
              style={{ color: "black" }}
            >
              <NavDropdown.Item >
                {`${props.user.given_name} ${props.user.family_name}`}
                <br />
                <div>
                  <a
                    className='dropdownLink'
                    href={`mailto:${props.user.email}`}
                  >{props.user.email}</a>
                </div>
              </NavDropdown.Item>
              <NavDropdown.Item>
                <button
                  type="button"
                  className="dropdownLink logoutBtn"
                  onClick={props.signout}
                >
                  Logout
                </button>
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Navbar>

      <Modal
        show={showVersionModal}
        onHide={() => setShowVersionModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: '1rem' }}>Application Version</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>UI Version: <strong>{packageJson.version}</strong></p>
        </Modal.Body>
      </Modal>
    </header>
  )
}

export default Header;
